export function medidoresInRequest(params = {}) {
  return {
    type: '@medidor/MEDIDORES_IN_REQUEST',
    payload: { params },
  };
}

export function findMedidor(idmedidor) {
  return {
    type: '@medidor/FIND_MEDIDOR',
    payload: { idmedidor },
  };
}

export function failedRequest() {
  return {
    type: '@medidor/FAILED_REQUEST',
  };
}

export function deleteMedidor(idmedidor, params) {
  return {
    type: '@medidor/DELETE_MEDIDOR',
    payload: { idmedidor, params },
  };
}

export function updateMedidor(medidor, params) {
  return {
    type: '@medidor/UPDATE_MEDIDOR',
    payload: { medidor, params },
  };
}

export function storeMedidor(medidor, params) {
  return {
    type: '@medidor/STORE_MEDIDOR',
    payload: { medidor, params },
  };
}

export function successInRequest(
  medidores,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@medidor/SUCCESS_IN_REQUEST',
    payload: { medidores, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(medidor) {
  return {
    type: '@medidor/SUCCESS_REQUEST',
    payload: { medidor },
  };
}

export function successRemove(params) {
  return {
    type: '@medidor/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@medidor/RECORD_FILTERING',
    payload: { params },
  };
}
